import { GET_LOCATION_LIST_FAILED_HANDLER } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case GET_LOCATION_LIST_FAILED_HANDLER:
      return action.payload;
    default:
      return state;
  }
};
